var _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9988 13.4474V12.5079C24.9988 7.34961 20.9699 3.16797 16 3.16797C11.0301 3.16797 7.00116 7.34961 7.00116 12.5079V13.4474C7.00116 14.5749 6.67963 15.677 6.07707 16.6152L4.60048 18.914C3.25176 21.0137 4.2814 23.8678 6.62715 24.5318C12.7637 26.2689 19.2364 26.2689 25.3728 24.5318C27.7187 23.8678 28.7483 21.0137 27.3995 18.914L25.9229 16.6152C25.3204 15.677 24.9988 14.5749 24.9988 13.4474Z",
    stroke: "#1C274C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 25.832C10.8734 28.1624 13.2299 29.832 16 29.832C18.77 29.832 21.1267 28.1624 22 25.832",
    stroke: "#1C274C",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.4375,
    cy: 6.6875,
    r: 4.8125,
    fill: "#EE2738"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.dc4ffb4cbfb6906e2008a3f56593e6da.svg";
export { ForwardRef as ReactComponent };